import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { styled } from "@mui/material/styles";
import { Box, Link } from "@mui/material";

const prefix = "Footer";

const classes = {
  container: `${prefix}-container`,
  keepInTouch: `${prefix}-keepInTouch`,
  iconsContainer: `${prefix}-iconsContainer`,
  icon: `${prefix}-icon`,
  footerText: `${prefix}-footerText`,
};

const FooterContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "150px",
  textAlign: "center",
  paddingTop: "2rem",

  [`& .${classes.keepInTouch}`]: {
    color: "#b59a4f",
    fontFamily: "raleway, sans-serif",
    fontSize: "13px",
    fontWeight: 700,
  },

  [`& .${classes.iconsContainer}`]: { margin: "0.5rem 0" },

  [`& .${classes.icon}`]: {
    color: "#fff",
    marginRight: "0.5rem",
    "& svg": {
      width: "29px !important",
      height: "29px !important",
    },
  },

  [`& .${classes.footerText}`]: {
    color: "#fff",
    fontSize: "13px",
    fontWeight: 700,
    fontFamily: "raleway, sans-serif",
    marginBottom: "0.5rem",
  },
}));

const Footer = () => {
  return (
    <FooterContainer>
      <Box className={classes.keepInTouch}>KEEP IN TOUCH</Box>
      <Box className={classes.iconsContainer}>
        <Link
          href="https://www.instagram.com/artdesignstory_paris/"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.icon}
          sx={{ textDecoration: "none" }}
        >
          <InstagramIcon />
        </Link>
        <Link
          href="https://twitter.com/artdesignpaint2"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.icon}
          sx={{ textDecoration: "none" }}
        >
          <TwitterIcon />
        </Link>
        <Link
          href="mailto:hello@artdesignstory.fr?subject=Contact FANartZONE"
          target="_self"
          className={classes.icon}
          sx={{ textDecoration: "none" }}
        >
          <MailOutlineIcon />
        </Link>
      </Box>
      <Box className={classes.footerText}>© ArtDesignStory PARIS</Box>
      <Box className={classes.footerText}>
        78 avenue des Champs-Elysées 75008 PARIS
      </Box>
      <Link
        href="mailto:hello@artdesignstory.fr?subject=Contact FANartZONE"
        className={classes.footerText}
        sx={{ textDecoration: "none" }}
      >
        hello@artdesignstory.fr
      </Link>
    </FooterContainer>
  );
};

export default Footer;
